<template>
  <v-app>
    <v-app-bar app color="primary" dark>
      <v-spacer class="d-none d-sm-inline"></v-spacer>

      <div class="d-flex align-center">
        <!-- <v-img
          alt="Vuetify Logo"
          class="shrink mr-2"
          contain
          src="https://cdn.vuetifyjs.com/images/logos/vuetify-logo-dark.png"
          transition="scale-transition"
          width="40"
        /> -->
        <h2 ma-1>PDF翻訳職人</h2>
        <!-- <v-img
          alt="Vuetify Name"
          class="shrink mt-1 hidden-sm-and-down"
          contain
          min-width="100"
          src="https://cdn.vuetifyjs.com/images/logos/vuetify-name-dark.png"
          width="100"
        /> -->
      </div>
      <v-spacer></v-spacer>

      <div class="d-none d-sm-inline">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              class="ma-3"
              v-on="on"
              style="text-transform: none"
              light
              @click="clickLink('deepl')"
              >英→日DeepL翻訳</v-btn
            >
          </template>
          <span>Ctrl + S</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              class="ma-3"
              v-on="on"
              style="text-transform: none"
              light
              @click="clickLink('google')"
              >英→日Google翻訳</v-btn
            >
          </template>
          <span>Ctrl + G</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              class="ma-3"
              v-on="on"
              style="text-transform: none"
              light
              @click="copyToClipboard"
              >Copy</v-btn
            >
          </template>
          <span>Ctrl + Q</span>
        </v-tooltip>
        <span>{{ processedText.length }}文字</span>
      </div>
      <v-spacer></v-spacer>
      <!--<v-btn
        href="https://github.com/vuetifyjs/vuetify/releases/latest"
        target="_blank"
        text
      >
        <span class="mr-2">Latest Release</span>
        <v-icon>mdi-open-in-new</v-icon>
      </v-btn> -->
    </v-app-bar>

    <v-main>
      <v-container>
        <v-row justify="center">
          <v-col cols="12">
            <div v-if="text === ''" style="text-align: center;">
              <span
                >英語のPDFを訳す時，改行が残ってしまうという悩み，解決します</span
              >
              <br />
              <span>使い方は簡単．コピペするだけ</span>
              <br />
              <span>従来のものと異なり段落が残ります！</span>
            </div>
            <v-row align="center" justify="center" align-content="center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="ma-3"
                    v-on="on"
                    style="text-transform: none"
                    outlined
                    v-shortkey.once="['ctrl', 's']"
                    @shortkey="clickLink('deepl')"
                    @click="clickLink('deepl')"
                    >英→日DeepL翻訳</v-btn
                  >
                </template>
                <span>Ctrl + S</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="ma-3"
                    v-on="on"
                    style="text-transform: none"
                    outlined
                    v-shortkey.once="['ctrl', 'g']"
                    @shortkey="clickLink('google')"
                    @click="clickLink('google')"
                    >英→日Google翻訳</v-btn
                  >
                </template>
                <span>Ctrl + G</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="ma-3"
                    v-on="on"
                    style="text-transform: none"
                    outlined
                    v-shortkey.once="['ctrl', 'q']"
                    @shortkey="copyToClipboard"
                    @click="copyToClipboard"
                    >Copy</v-btn
                  >
                </template>
                <span>Ctrl + Q</span>
              </v-tooltip>
              <span>{{ processedText.length }}文字</span>
            </v-row>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="12" sm="6">
            <v-textarea
              cols="100"
              rows="10"
              v-model="text"
              outlined
              no-resize
              auto-grow
              autofocus
              label="翻訳したい文"
            ></v-textarea>
          </v-col>
          <v-col cols="12" sm="6">
            <v-card outlined :height="text.length < 100 ? '90%' : '100%'">
              <v-card-text style="white-space: pre-wrap;">
                {{ processedText }}
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import clipboardCopy from "clipboard-copy";

const SITES = {
  deepl: "https://www.deepl.com/translator#en/ja/",
  google:
    "https://translate.google.com/?view=home&op=translate&sl=en&tl=ja&text=",
};

const PG_LAST = new Set(["\n", ".", ":", ";", "!", "?","。","．","！", "？"]);

export default {
  name: "App",

  components: {},

  data: () => ({
    text: "",
  }),
  computed: {
    processedText() {
      const text = this.text.replace(/\r\n|\r/g, "\n");
      let result = "";
      for (let i = 0; i < text.length; i++) {
        const char = text[i];
        if (char === "-" && i + 1 < text.length && text[i + 1] === "\n") {
          i++;
          continue;
        }
        const rsLast = result[result.length - 1];
        if (char !== "\n" || PG_LAST.has(rsLast)) {
          result += char;
        } else {
          result += " ";
        }
      }
      return result;
    },
  },
  methods: {
    copyToClipboard() {
      clipboardCopy(this.processedText);
    },
    clickLink(site) {
      window.open(
        SITES[site] + encodeURIComponent(this.processedText).replaceAll("%5C", "%5C%5C").replaceAll("%2F", "%5C%2F").replaceAll("%7C", "%5C%7C"),
        "_blank"
      );
    },
  },
};
</script>
